import React, { Component } from 'react'
import TableComp from '../../../components/_utils/table'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
//import {TableComp} from 'sz-react-utils'
import moment from 'moment'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, Row, Col, Popover } from 'antd'
import Request, { API_URL } from '../../../request'
import _ from 'lodash'
import { FaRegEye } from "react-icons/fa";
import { connect } from 'react-redux'
import styles from './styles.less'
import { getUrlPushWrapper } from '../../../routes'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { hideLoader, showLoader } from '../../../modules/actions'
import { RightsWrapper } from '../../../components/_utils/utils'
import async from 'async'
let localUser = JSON.parse(localStorage.getItem('user'))
const TabPane = Tabs.TabPane

@Form.create()
class AllTemplate extends Component {
    state = {
        templateId: '',
        count: 0,
        activeTab: '0',
        typeList: ['Email', 'SMS', 'Whatsapp', 'InvoiceEmail', 'BranchInvoiceEmail', 'University Business Proposal'],
        showEmailSubject: false,
        userGroupsArr: [],
        whatsappTemplate: false,
        emailTemplate: false,
        templateArr: [],
        emailTemplateArr: [],
        allEmailTemplatesData: [],
        showEmailTemplateImage: '',
        mailerSendApi: null,
        businessProposalMail: false,
        templateType: ''
    }

    constructor(props) {
        super(props)

        this.table = React.createRef()

    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                dispatch(showLoader())
                let x = null
                if (this.state.id) {
                    values._id = this.state.id
                    x = await Request.updateTemplate(values)
                } else {
                    x = await Request.addTemplate(values)
                }

                dispatch(hideLoader())

                if (!x.error) {
                    notification.success({
                        message: this.state.id
                            ? `Template Updated Successfully`
                            : 'Template Added successfully'
                    })
                    this.setState({
                        templateId: '',
                        showEmailTemplateImage: '',
                        emailTemplate: false
                    })
                    form.resetFields()
                    if (this.table && this.table.current)
                        this.table.current.reload()

                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }

    deleteTemplate = async data => {
        this.setState({ loading: true })
        await Request.deleteTemplate(data)

        this.setState({ loading: false })

        this.table.current.reload()

        notification.success({
            message: 'Deleted Successfully',
            duration: 20,
            key: `${data._id}-close`
        })
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            if (!params.sortField) {
                params.sortField = '_id'
                params.sortOrder = 'descend'
            }

            let data = await Request.loadTemplates({
                ...params,
                regExFilters: ['templateName', 'emailSubject']
            })

            this.setState({ count: data.total })
            resolve(data)
        })
    }
    callback = (value) => {
        if (value) {
            this.chooseTab(value)
        }
    }

    loadDepartments() {
        let params = {
            results: 100,
            sortField: "groupName",
            sortOrder: "ascend",
        };
        Request.loadGroups(params)
            .then((resp) => {
                if (resp) {
                    let temp = [{ display: '---Select All---', id: 'all' }];
                    _.each(resp.data, (vv) => {
                        temp.push({
                            display: vv.groupName,
                            id: vv._id,
                        });
                    });
                    this.setState({ userGroupsArr: temp });
                }
            })
            .catch((err) => {
            });
    }

    componentWillMount() {
        this.loadDepartments()
    }

    getWhatsappTemplates = async () => {
        let templates = await Request.getWhatsappTemplates()
        let templateArr = []
        _.each(templates, (template) => {
            let { components } = template
            let templateHtml
            components && components.map((component) => {
                if (component.type === 'BODY') {
                    templateHtml = component.text
                }
                // if ((!component.format && component.type !== "BUTTON") || (component.format === "TEXT" && component.type !== "BUTTON")) {
                //     templateHtml = component.text
                // }
            })
            templateArr.push({ name: template.name, templateData: templateHtml })
        })
        console.log(templateArr);
        this.setState({ templateArr })
    }

    getMailerSendEmailTemplates = async () => {
        let emailTemplates = await Request.getMailersendEmailTemplates();
        let emailTemplateArr = []
        async.each(emailTemplates.data, (template) => {
            emailTemplateArr.push({ id: template.id, display: template.name })
        })
        this.setState({ emailTemplateArr, allEmailTemplatesData: emailTemplates.data })
    }

    async componentDidMount() {
        this.loadDepartments()
        let searchParams = new URLSearchParams(this.props.search)
        let templateId = searchParams.get('id')
        this.setTemplateDara(templateId)
    }

    async updateTemplateType(type) {
        if (type === "Whatsapp") {
            this.setState({ whatsappTemplate: true, emailTemplate: false, businessProposalMail: false, showEmailTemplateImage: null, templateType: type }, () => {
                this.props.form.setFieldsValue({ templateData: null })
                this.getWhatsappTemplates()
            })
        } else if (type === "Email") {
            let communicationSettingResponse = await Request.getCommunicationSettings();
            if (communicationSettingResponse && communicationSettingResponse.doc && communicationSettingResponse.doc.mailerSendApi) {
                this.setState({ emailTemplate: true, whatsappTemplate: false, businessProposalMail: false, mailerSendApi: true, showEmailTemplateImage: null, templateType: type }, () => {
                    this.props.form.setFieldsValue({ templateData: null })
                    this.getMailerSendEmailTemplates()
                })
            } else {
                this.setState({ whatsappTemplate: false, emailTemplate: false, businessProposalMail: false, mailerSendApi: false, showEmailTemplateImage: null, templateType: type }, (
                    this.props.form.setFieldsValue({ templateData: null })
                ))
            }

        } else if (type === "University Business Proposal") {
            this.setState({ businessProposalMail: true, whatsappTemplate: false, emailTemplate: false, showEmailTemplateImage: null, templateType: type }, () => {
                this.props.form.setFieldsValue({ templateData: null })
            });
        } else {
            this.setState({ whatsappTemplate: false, emailTemplate: false, businessProposalMail: false, showEmailTemplateImage: null, templateType: type }, () => {
                this.props.form.setFieldsValue({ templateData: null })
            })
        }

    }


    showTemplateData(templateName) {
        let { templateArr } = this.state
        var result = templateArr.find(obj => {
            return obj.name === templateName
        })
        this.props.form.setFieldsValue({ templateData: result.templateData })
    }

    previewEmailTemplate(v) {
        let { allEmailTemplatesData } = this.state;
        var result = allEmailTemplatesData.find(obj => {
            return obj.id === v
        })
        this.setState({ showEmailTemplateImage: result.image_path })
    }

    // showTemplatetext(templateId) {
    //     console.log('called called called')
    //     console.log(templateId)
    // }

    setTemplateDara(templateId) {
        if (templateId) {
            Request.getTemplateById({ id: templateId }).then(
                ({ doc, error, message }) => {
                    if (!error) {
                        this.setState({
                            templateId,
                            id: doc._id,
                            activeTab: '0',
                        })

                        if (doc.type === "Email" || doc.type === 'InvoiceEmail') {
                            this.setState({
                                showEmailSubject: true
                            })
                        }
                        if (doc.type === "Whatsapp") {
                            this.setState({ whatsappTemplate: true })
                        }

                        this.props.form.setFieldsValue({
                            userGroupIds: doc && doc.userGroupIds,
                            templateName: doc.templateName,
                            type: doc.type,
                            templateKey: doc && doc.templateKey,
                            templateData: doc.templateData,
                            emailSubject: doc.emailSubject,
                            mailLogo: doc.mailLogo ? doc.mailLogo : null
                        })
                    } else {
                        notification.error({
                            message: 'Error Getting Data',
                            description: message
                        })
                    }
                }
            )
        }
    }

    chooseTab(value) {
        this.setState({
            activeTab: value
        })
    }

    render() {

        const { dispatch } = this.props
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props
        const { typeList, userGroupsArr, templateId } = this.state

        const columns = [
            {
                title: 'Template',
                key: 'templateName',
                width: 250,
                dataIndex: 'templateName',
                render: (text, record) => {
                    return (
                        <div>{text}</div>
                    )
                }

            },
            {
                title: 'Type',
                key: 'type',
                sorter: true,
                filters: typeList && typeList.map(x => ({ value: x, text: x })),
                dataIndex: 'type'
            },
            {
                title: 'Email Subject',
                key: 'emailSubject',
                searchTextName: 'Email Subject',
                filterRegex: true
            },
            {
                title: 'Updated By',
                key: 'lastUpdatedByName',
                dataIndex: 'lastUpdatedByName',
                render: (text, record) => {
                    return (
                        <div>
                            <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
                            <small>{record.name}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Last Update Time',
                key: 'lastUpdatedTime',
                dataIndex: 'lastUpdatedTime',
                render: (text, record) => {
                    return (
                        <div>
                            <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <React.Fragment>
                        {
                            record.businessId === localUser.businessId ?
                                <RightsWrapper myRight={'Template.edit'}>
                                    <Tooltip title="Edit Template">
                                        <Button
                                            className={styles.btn}
                                            shape="circle"
                                            onClick={() => {
                                                this.setTemplateDara(record._id)
                                            }}
                                            icon="edit"
                                        />

                                    </Tooltip>
                                </RightsWrapper>
                                : null
                        }
                        {
                            record.businessId === localUser.businessId ?
                                <RightsWrapper myRight={'Template.delete'}>
                                    <Tooltip title="Delete Template">
                                        <Popconfirm
                                            title="Are you sure delete this Template?"
                                            onConfirm={() => {
                                                this.deleteTemplate({ _id: record._id })
                                            }}
                                            onCancel={() => {
                                                console.log()
                                            }}
                                            okText="Yes"
                                            cancelText="No">
                                            <Button
                                                className={styles.btn}
                                                shape="circle"
                                                icon="delete"
                                            />
                                        </Popconfirm>
                                    </Tooltip>
                                </RightsWrapper>
                                : null
                        }

                    </React.Fragment>
                )
            }
        ]
        let inputTypes = {
            fields: [
                {
                    label: 'Select Department ',
                    key: 'userGroupIds',
                    required: true,
                    type: 'select',
                    mode: 'multiple',
                    showSearch: true,
                    disabled: false,
                    options: userGroupsArr,
                    onChange: v => {
                        let val = v ? v : [];
                        if (v && v.length && v.includes("all")) {
                            if (v.length === userGroupsArr.length) {
                                val = [];
                            } else {
                                val = userGroupsArr.slice(1).map(levelOption => levelOption.id);
                            }
                        }
                        this.props.form.setFieldsValue({
                            userGroupIds: val
                        })
                    }
                },
                { label: 'Template Name', key: 'templateName', required: true },

                {
                    label: 'Template Type',
                    key: 'type',
                    required: true,
                    type: 'select',
                    disabled: false,
                    placeholder: 'Select Template Type',
                    allowClear: true,
                    options: [{ id: 'Email', display: 'Email General' }, { id: 'SMS', display: 'SMS' }, { id: 'Whatsapp', display: 'Whatsapp' }, { id: 'InvoiceEmail', display: 'InvoiceEmail' }, { id: 'BranchInvoiceEmail', display: 'BranchInvoiceEmail' }, { id: 'University Business Proposal', display: 'University Business Proposal' }],
                    onChange: type => {
                        this.updateTemplateType(type);
                        setFieldsValue({ type: type && type.toString() })
                        this.setState({ showEmailSubject: (type === "Email" || type === 'InvoiceEmail' || type === "University Business Proposal" ? true : false) })
                    }
                },
                {
                    label: 'Whatsapp Template', key: 'templateKey', hidden: (!this.state.whatsappTemplate), type: 'select', required: this.state.whatsappTemplate, keyAccessor: x => x.name, valueAccessor: x => x.name, showSearch: true, options: this.state.templateArr, onChange: v => {
                        this.showTemplateData(v)
                        this.props.form.setFieldsValue({ templateKey: v })
                    }
                },
                {
                    label: 'Email Template', key: 'emailTemplateId', hidden: (!this.state.emailTemplate), type: 'select', required: this.state.emailTemplate,
                    options: this.state.emailTemplateArr, onChange: v => {
                        this.previewEmailTemplate(v)
                        this.props.form.setFieldsValue({ emailTemplateId: v })
                    }
                },
                { label: 'Email Subject', key: 'emailSubject', hidden: (this.state.showEmailSubject === false), required: (this.state.showEmailSubject === true) },
                {
                    label: 'Template Body',
                    key: 'templateData',
                    hidden: this.state.emailTemplate && this.state.mailerSendApi || !this.state.whatsappTemplate || this.props.form.getFieldValue('type') !== 'Email' ? true : false,
                    required: true,
                    type: 'editor'
                },
                {
                    label: 'Email Logo',
                    key: 'mailLogo',
                    hidden: !this.state.businessProposalMail,
                    required: this.state.businessProposalMail,
                    type: 'file',
                },
                {
                    label: 'Template Body',
                    key: 'templateData',
                    disabled: true,
                    hidden: this.state.emailTemplate,
                    type: this.state.whatsappTemplate ? 'textarea' : 'editor',
                    rows: 15,
                    required: true
                }
            ]
        }
        return (
            <PageHeaderWrapper title={`TEMPLATE MANAGEMENT`}>
                <Card bordered={true}>
                    <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
                        <TabPane tab={`${templateId ? 'Edit' : 'Add'} Template`} key={0}>
                            <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                                <Row>
                                    <Col span={18}>
                                        <GetAllFormFields
                                            inputSchema={inputTypes}
                                            refresh={this.refreshFxn}
                                            getFieldDecorator={getFieldDecorator}
                                            apiurl={API_URL}
                                        />
                                        {
                                            this.state.emailTemplate ?
                                                <div style={{ width: '100%', textAlign: 'center' }}>
                                                    <img style={{ width: "70%" }} src={this.state.showEmailTemplateImage}></img>
                                                </div>
                                                : null
                                        }
                                        <Button
                                            type=""
                                            htmlType="submit"
                                            style={{
                                                marginBottom: 10,
                                                marginLeft: '33%',
                                                backgroundColor: 'green',
                                                color: 'white'
                                            }}
                                            loading={this.props.loading}>
                                            SAVE
                                        </Button>
                                        <Button
                                            type="primary"
                                            style={{ marginBottom: 10, marginLeft: '1%' }}
                                            loading={this.props.loading}
                                            onClick={() => {
                                                this.props.form.resetFields()
                                            }}>
                                            RESET
                                        </Button>
                                    </Col>
                                    <Col span={6}>
                                        <small>Use the below-mentioned predefined variables to bind it with the template.</small>
                                        {
                                            this.state.templateType === "University Business Proposal" ?
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <th>Your Name</th>
                                                            <td><b>{'{{userName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Your Email</th>
                                                            <td><b>{'{{userEmail}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Recipient Name</th>
                                                            <td><b>{'{{contactPersonName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Recipient Email</th>
                                                            <td><b>{'{{contactPersonEmail}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Recipient Phone</th>
                                                            <td><b>{'{{contactPersonPhone}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>University</th>
                                                            <td><b>{'{{univerisityInstitutionName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Country</th>
                                                            <td><b>{'{{countryName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>State</th>
                                                            <td><b>{'{{stateName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>City</th>
                                                            <td><b>{'{{cityName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Reference</th>
                                                            <td><b>{'{{reference}}'}</b></td>
                                                        </tr>
                                                        {/* <tr>
                                                    <th>Branch Phone</th>
                                                    <td><b>{'{{branchPhone}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>WhatsApp Number</th>
                                                    <td><b>{'{{whatsappNumber}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Business ID</th>
                                                    <td><b>{'{{businessId}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Branch ID</th>
                                                    <td><b>{'{{branchId}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Company Name</th>
                                                    <td><b>{'{{companyName}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Consultancy Total</th>
                                                    <td><b>{'{{consultancyTotal}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Consultancy Balance</th>
                                                    <td><b>{'{{consultancyBalance}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Final University Name</th>
                                                    <td><b>{'{{finalUniversityInstitutionName}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Final Course Name</th>
                                                    <td><b>{'{{finalCourseName}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Final Selected Country Name</th>
                                                    <td><b>{'{{finalCountryName}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Tution Fee</th>
                                                    <td><b>{'{{tutionFee}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Counselling Desk Courses</th>
                                                    <td><b>{'{{counsellingCourses}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Application Selected Courses</th>
                                                    <td><b>{'{{applicationCourses}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Invoice Number</th>
                                                    <td><b>{'{{invoiceNumber}}'}</b></td>
                                                </tr>
                                                <tr>
                                                    <th>Invoice Generated Date</th>
                                                    <td><b>{'{{invoiceGeneratedDate}}'}</b></td>
                                                </tr> */}
                                                    </tbody>
                                                </table>
                                                :
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <th>Student Name</th>
                                                            <td><b>{'{{studentName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Student Mobile</th>
                                                            <td><b>{'{{mobile}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Student Email</th>
                                                            <td><b>{'{{email}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Student ID</th>
                                                            <td><b>{'{{studentId}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Counsellor Name</th>
                                                            <td><b>{'{{counsellorName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Counsellor Email</th>
                                                            <td><b>{'{{counsellorEmailId}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Branch Email</th>
                                                            <td><b>{'{{branchEmailId}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Branch Address</th>
                                                            <td><b>{'{{branchAddress}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Branch Phone</th>
                                                            <td><b>{'{{branchPhone1}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Branch Phone</th>
                                                            <td><b>{'{{branchPhone}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>WhatsApp Number</th>
                                                            <td><b>{'{{whatsappNumber}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Business ID</th>
                                                            <td><b>{'{{businessId}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Branch ID</th>
                                                            <td><b>{'{{branchId}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Company Name</th>
                                                            <td><b>{'{{companyName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Consultancy Total</th>
                                                            <td><b>{'{{consultancyTotal}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Consultancy Balance</th>
                                                            <td><b>{'{{consultancyBalance}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Final University Name</th>
                                                            <td><b>{'{{finalUniversityInstitutionName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Final Course Name</th>
                                                            <td><b>{'{{finalCourseName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Final Selected Country Name</th>
                                                            <td><b>{'{{finalCountryName}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Tution Fee</th>
                                                            <td><b>{'{{tutionFee}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Counselling Desk Courses</th>
                                                            <td><b>{'{{counsellingCourses}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Application Selected Courses</th>
                                                            <td><b>{'{{applicationCourses}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Invoice Number</th>
                                                            <td><b>{'{{invoiceNumber}}'}</b></td>
                                                        </tr>
                                                        <tr>
                                                            <th>Invoice Generated Date</th>
                                                            <td><b>{'{{invoiceGeneratedDate}}'}</b></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                        }
                                    </Col>
                                </Row>
                            </Form>
                        </TabPane>

                        <TabPane tab={`All Templates`} key={1}>
                            <h2>{`Templates : ${this.state.count}`}</h2>

                            <TableComp
                                columns={columns}
                                ref={this.table}
                                apiRequest={this.apiRequest}
                                pagination={{
                                    showSizeChanger: true,
                                    defaultPageSize: 50,
                                    pageSizeOptions: ['10', '20', '50', '100', '1000']
                                }}
                            />
                        </TabPane>
                    </Tabs>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllTemplate)
